import React from 'react';
import { FiUser } from 'react-icons/fi';
import { useT } from '../../utils/i18n';

export const ProfileSettings = () => {
  const t = useT();
  return (
    <div className="space-y-6 max-w-2xl">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center">
          <FiUser size={20} className="text-primary-600" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-gray-900">{t('settings.profile')}</h1>
          <p className="text-sm text-gray-500">{t('settings.profileSubtitle')}</p>
        </div>
      </div>
      <div className="card flex flex-col items-center justify-center h-64 gap-3 text-gray-400">
        <FiUser size={40} className="text-gray-300" />
        <p className="text-lg font-medium">{t('settings.comingSoon')}</p>
        <p className="text-sm">{t('settings.profileBeingBuilt')}</p>
      </div>
    </div>
  );
};
